module.exports = __webpack_public_path__ + "static/media/micheile-dot-com-auKN3JcMKso-unsplash.fa6cad14.jpg";